/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type TemplateContentType = typeof TemplateContentType[keyof typeof TemplateContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TemplateContentType = {
  PLAIN: 'PLAIN',
  HTML: 'HTML',
} as const;
